import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const t = localStorage.getItem("lush_token");
    if (!t) {
      setUser(null);
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${t}` } })
      .then((r) => {
        setUser(r.data);
        localStorage.setItem("lush_role", r.data.role === "admin" ? "Admin" : "RM");
      })
      .catch(() => {
        localStorage.removeItem("lush_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const r = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("lush_token", r.data.access_token);
    localStorage.setItem("lush_role", r.data.user.role === "admin" ? "Admin" : "RM");
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("lush_token");
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>;
};
